module.exports = __webpack_public_path__ + "img/banner-bg_3.4a05291c.png";